import CommonModelTypeahead from "./CommonModelTypeahead";
import ModelDifferenceTypeahead from "./ModelDifferenceTypeahead";
import { DiffCategoryTypes } from "../../entities";

interface CommonModelDiffTypeaheadsProps {
  modelNames: string[];
  selectedModels?: string[];
  selectedDiffType?: DiffCategoryTypes | null;
  onModelSelectChange?: (models: string[]) => void;
  onDiffTypeChange?: (diffType: DiffCategoryTypes | null) => void;
}

const CommonModelDiffTypeaheads = ({
  modelNames,
  selectedModels = [],
  selectedDiffType = null,
  onModelSelectChange,
  onDiffTypeChange,
}: CommonModelDiffTypeaheadsProps) => {
  // Provide a default handler if none is provided for model selection
  const handleModelSelectChange = (models: string[]) => {
    if (onModelSelectChange) {
      onModelSelectChange(models);
    }
  };

  // Provide a default handler if none is provided for diff type change
  const handleDiffTypeChange = (diffType: DiffCategoryTypes | null) => {
    if (onDiffTypeChange) {
      onDiffTypeChange(diffType);
    }
  };

  return (
    <div className="grid grid-cols-2 gap-4 w-1/2">
      <CommonModelTypeahead
        modelNames={modelNames || []}
        selectedFields={selectedModels}
        onChange={handleModelSelectChange}
      />
      <ModelDifferenceTypeahead selectedValue={selectedDiffType} onChange={handleDiffTypeChange} />
    </div>
  );
};

export default CommonModelDiffTypeaheads;
